import React from 'react';
import { normalize } from '../../../utils/text';
export function Highlight({
  text,
  terms
}: {
  text: string;
  terms: string[];
}) {
  const norm = normalize(text);
  const ranges: [number, number][] = [];
  terms.filter(t => t.length >= 2).forEach(t => {
    let i = norm.indexOf(t);
    while (i !== -1) {
      ranges.push([i, i + t.length]);
      i = norm.indexOf(t, i + t.length);
    }
  });
  if (!ranges.length) return <>{text}</>;
  ranges.sort((a, b) => a[0] - b[0]);
  const merged: [number, number][] = [];
  ranges.forEach(r => {
    const last = merged[merged.length - 1];
    if (last && r[0] <= last[1]) last[1] = Math.max(last[1], r[1]);else merged.push([...r]);
  });
  const parts: React.ReactNode[] = [];
  let cursor = 0;
  merged.forEach(([s, e], i) => {
    if (s > cursor) parts.push(text.slice(cursor, s));
    parts.push(<mark key={i} className="rounded-sm bg-[#D4AF37]/25 px-0.5 text-[#F3E5AB]" data-id="element-903" data-mp="3fx0tyssg949s">
        {text.slice(s, e)}
      </mark>);
    cursor = e;
  });
  if (cursor < text.length) parts.push(text.slice(cursor));
  return <>{parts}</>;
}